<template>
  <div class="app-container">
    <el-form v-model="queryForm" :inline="true" class="query-form">
      <el-form-item>
        <el-input v-model="queryForm.keyword" clearable type="text" placeholder="标题" />
      </el-form-item>
      <el-form-item>
        <el-input v-model="queryForm.userName" clearable type="text" placeholder="用户名" />
      </el-form-item>
      <el-button type="primary" @click="handleSearch">
        <i class="el-icon-search" />查询
      </el-button>
      <el-button type="default" @click="resetSearch">
        <i class="el-icon-refresh" />重置刷新
      </el-button>
    </el-form>
    <el-divider class="query-form-divider" />
<!--    <div class="query-button-wrap">-->
<!--      <el-button type="success" @click="handleCreateNew" class="margin-bottom-20">-->
<!--        <i class="el-icon-plus" />新建-->
<!--      </el-button>-->
<!--    </div>-->

    <el-table v-loading="table.listLoading" :data="table.items" element-loading-text="Loading" border stripe fit highlight-current-row @sort-change="sort">
      <!-- <el-table-column label="id" width="80" prop="id" sortable></el-table-column> -->
      <el-table-column label="用户名" prop="user.userName"></el-table-column>
      <el-table-column label="头像" prop="user.headImgUrl">
        <template slot-scope="scope">
          <div class="flex-r-ac">
            <el-avatar v-if="scope.row.user.headImgUrl" :src="scope.row.user.headImgUrl" />
          </div>
        </template>
      </el-table-column>
      <el-table-column label="微信名" prop="user.name"></el-table-column>
      <el-table-column label="标题" prop="title"></el-table-column>
      <el-table-column label="数量" prop="ammount"></el-table-column>
      <el-table-column label="原积分" prop="oldPoints"></el-table-column>
      <el-table-column label="新积分" prop="newPoints"></el-table-column>
    </el-table>
    <el-pagination :current-page.sync="table.page" :page-sizes="[10, 20, 50, 100]" :page-size="table.pagesize" layout="total,jumper,prev, pager, next,sizes" :total="table.totalCount" @size-change="handleSizeChange" @current-change="current_change" />
  </div>
</template>

<script>
const defaultData = {
  id: 0
};

const controller = "userPointLog";

export default {
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: "success",
        draft: "gray",
        deleted: "danger"
      };
      return statusMap[status];
    }
  },
  data() {
    return {
      table: {
        items: [],
        listLoading: true,
        pagesize: 20,
        page: 1,
        totalCount: 0,
        sorting: "id desc"
      },
      dialogStatus: "",
      queryForm: {
        keyword: "",
        userName: ""
      },
      form: {
        show: false,
        submitting: false,
        data: {
          ...defaultData
        },
        rules: {
          name: []
        }
      },
      textMap: {
        update: "编辑",
        create: "新建"
      }
    };
  },
  created() {
    this.fetchData(); // 如果开启了默认排序,不需要这一行
  },
  methods: {
    fetchData() {
      this.table.listLoading = true;
      this.$abpApi[controller]
        .getAll({
          skipCount: (this.table.page - 1) * this.table.pagesize,
          sorting: this.table.sorting,
          maxResultCount: this.table.pagesize,
          keyword: this.queryForm.keyword,
          userName: this.queryForm.userName
        })
        .then(response => {
          this.table.items = response.data.items;
          this.table.totalCount = response.data.totalCount;
          this.table.listLoading = false;
        });
    },
    // 切换切面,在watch中监听 page
    current_change(e) {
      this.table.page = e;
    },
    // 排序
    sort(e) {
      console.log("sort : ", e);
      if (e.prop && e.order) {
        this.table.sorting = `${e.prop} ${e.order}`;
      } else {
        this.table.sorting = "id descending";
      }
      this.fetchData(1);
    },
    handleSizeChange(e) {
      this.table.pagesize = e;
      this.fetchData();
    },
    handleSearch() {
      this.fetchData();
    },
    handleCreateNew() {
      this.resetForm();
      this.dialogStatus = "create";
      this.form.show = true;
      this.$abpApi[controller]
        .getForEdit({
          id: 0
        })
        .then(res => {
          this.form.data = res.data;
        });
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    handleEdit($index, $row) {
      this.resetForm();
      const { id } = $row;
      this.$abpApi[controller]
        .getForEdit({
          id
        })
        .then(res => {
          this.form.data = res.data;
          this.dialogStatus = "update";
          this.form.show = true;
          this.$nextTick(() => {
            this.$refs["dataForm"].clearValidate();
          });
        });
    },
    handleSave() {
      this.$refs["dataForm"].validate(valid => {
        if (valid) {
          console.log(this.form.data);
          let fn;
          if (this.form.data.id) {
            fn = this.$abpApi[controller].update;
          } else {
            fn = this.$abpApi[controller].create;
          }
          fn(this.form.data).then(res => {
            this.form.submitting = false;
            this.form.show = false;
            this.fetchData();
          });
        }
      });
    },
    handleDelete($index, $row) {
      const { id } = $row;
      this.$confirm("您确认要删除吗", "删除提示").then(() => {
        this.$abpApi[controller]
          .delete({
            id
          })
          .then(res => {
            console.log("delete then");
            this.$message({
              type: "success",
              message: "删除成功"
            });
            this.fetchData();
          });
      });
    },
    resetForm() {
      this.form = Object.assign({}, this.form, {
        data: {
          ...defaultData
        }
      });
    },
    resetSearch() {
      this.queryForm = {
        keyword: "",
        userName: ""
      };
      this.fetchData();
    },
    // 图片上传前判断
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    // 上传成功后回调
    handleAvatarSuccess(res, file) {
      console.log(res);
      if (res.success) {
        // 这里写回调逻辑
        // this.form.data.titleImagePath = res.result
      }
    }
  }
};
</script>

<style scoped lang="scss">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 88px;
  height: 88px;
  line-height: 88px;
  text-align: center;
}

.avatar {
  width: 88px;
  height: 88px;
  display: block;
}
</style>
